import React, {useState, useEffect, useRef} from 'react';
import { 
    Flex, Center, CircularProgress, CircularProgressLabel, Text, Button, Icon, useToast,
    HStack, Alert, AlertIcon, AlertDescription,
    Heading, Tabs, TabList, TabPanels, Tab, TabPanel, Select,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, Input,
    FormControl, FormLabel
} from '@chakra-ui/react';
import { Row, Col, Card, Statistic, Typography, Progress } from "antd";
import { useCookies } from "react-cookie";
import axios from 'axios';
import { MdDownload, MdSearch } from 'react-icons/md';
import { FormattedNumber, FormattedDate } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from 'react-date-picker';
import "react-date-picker/dist/DatePicker.css";
import 'react-calendar/dist/Calendar.css';
// import { Select } from "chakra-react-select";
import { MultiSelect } from "react-multi-select-component";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import BarChartComponent from './BarChart';
import PieChartComponent from './PieChart';
import LineChartComponent from './LineChart';
import _, { get } from 'lodash';
import { sleep } from '../../utils/helpers';
import httpClient from '../../services/http-client';
const { Title } = Typography;
const intl = Intl.NumberFormat();
const ItemGroupComponent = null;
const dayOrder = [
    "MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"
]

function Dashboard({ }) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const [isLoading, setIsLoading] = useState(false);
    const [isAllowAccessThisPage, setIsAllowAccessThisPage] = useState(true);
    const [ initDatas, setInitDatas ] = useState({});
    const [metricSaleDatas, setMetricSaleDatas] = useState({});
    const [metricGroupDatas, setMetricGroupDatas] = useState({});
    const [metricHourDatas, setMetricHourDatas] = useState([]);
    const [metricItemGroupDatas, setMetricItemGroupDatas] = useState([]);
    const [metricSaleOnOffDatas, setMetricSaleOnOffDatas] = useState([]);
    const [metricSaleAppDatas, setMetricSaleAppDatas] = useState([]);
    const [metricTCOnOffDatas, setMetricTCOnOffDatas] = useState([]);
    const [metricTCAppDatas, setMetricTCAppDatas] = useState([]);
    const [metricSaleDatasByDay, setMetricSaleDatasByDay] = useState([]);
    const [metricTCDatasByDay, setMetricTCDatasByDay] = useState([]);
    const [metricSaleSmallGroupDatas, setMetricSaleSmallGroupDatas] = useState([]);
    const [metricTCSmallGroupDatas, setMetricTCSmallGroupDatas] = useState([]);
    const [metricDailySalesDatas, setMetricDailySalesDatas] = useState([]);
    const [selectedStoreName, setSelectedStoreName] = useState(0);
    const [selectedStoreNames, setSelectedStoreNames] = useState([]);
    const [selectedFromDate, setSelectedFromDate] = useState(null);
    const [selectedToDate, setSelectedToDate] = useState(null);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [ errorMessage, setErrorMessage ] = useState(null);
    const navigate = useNavigate();
    const toast = useToast();
    const mouted = useRef();

    const { search } = useLocation();
    const htmlDownloadRef = useRef();

    useEffect(() => {
        if(!mouted.current) {
            if(
                cookies.loginCookie?.data?.scope === "admin" || 
                cookies.loginCookie?.data?.scope === "dashboard" || 
                cookies.loginCookie?.data?.scope === "all") {
                loadInitDatas();
            } else {
                setIsAllowAccessThisPage(false);
                console.log("--- not authorized to access dashboard page");
            }
            mouted.current = true;
        }
    }, []);

    //console.log("--- metricItemGroupDatas: ", metricItemGroupDatas)

    const loadInitDatas = async() => {
        setIsLoading(true);
        const res = await httpClient.get(`/larksuite/init-datas`);
        
        if(!res.data.error) {
            setInitDatas(res.data.data);
            setIsLoading(false);
        } else {
            setErrorMessage("Lỗi:" + JSON.stringify(res.data?.error?.message));
            setIsLoading(false);
        }
    }

    const handleSearchByDate = async() => {
        if(!selectedStoreNames) {
            alert("Vui lòng chọn cửa hàng!");
            return;
        } else if(!selectedFromDate) {
            alert("Vui lòng chọn ngày bắt đầu!");
            return;
        } else if(!selectedToDate) {
            alert("Vui lòng chọn ngày kết thúc!");
            return;
        }

        const storeNames = selectedStoreNames.map(item => item.value).join(",");

        setIsLoading(true);
        await sleep(500);
        await getSaleDatas({ storeName: storeNames, fromDate: selectedFromDate, toDate: selectedToDate });
        await getGroupDatas({ storeName: storeNames, fromDate: selectedFromDate, toDate: selectedToDate });
        await getHourDatas({ storeName: storeNames, fromDate: selectedFromDate, toDate: selectedToDate });
        setIsLoading(false);
    }

    const handleSearchDailySalesAndItemGroup = async() => {
        if(!selectedStoreName) {
            alert("Vui lòng chọn cửa hàng!");
            return;
        }
        else if(!selectedYear) {
            alert("Vui lòng chọn năm!");
            return;
        }

        setIsLoading(true);
        await sleep(500);
        await getSaleDataByDailySales({ storeName: selectedStoreName, fromDate: new Date(selectedYear, 0, 1), toDate: new Date(selectedYear, 11, 31) });
        await getItemDatas({ storeName: selectedStoreName, year: selectedYear });
        setIsLoading(false);
    }

   // console.log("--- initDatas", initDatas)

    const getSaleDatas = async ({ storeName, fromDate, toDate }) => {
        //setIsLoading(true);
        try {
            const res = await httpClient.get(`/pos_sales?storeName=${storeName}&&fromDate=${fromDate}&&toDate=${toDate}&&limit=10_000_000`);
            console.log("Res data:", res.data);
            if(res.data.error) {
                console.log("Lỗi:" + JSON.stringify(res.data?.error?.message));
                setErrorMessage("Lỗi:" + JSON.stringify(res.data?.error?.message));
            } else {
                const datas = res.data?.data || [];
                const TOTAL_SALE_M = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale M"] || 0), 0);
                const TOTAL_SALE_A = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale A"] || 0), 0);
                const TOTAL_SALE_E = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale E"] || 0), 0);
                const TOTAL_SALE_TOTAL = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Total"] || 0), 0);
                console.log("TOTAL_SALE_TOTAL:", TOTAL_SALE_TOTAL);
                const TOTAL_SALE_ON = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale On"] || 0), 0);
                const TOTAL_SALE_OFF = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Off"] || 0), 0);
                const TOTAL_SALE_TAI_CHO = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Tại Chỗ"] || 0), 0); 
                const TOTAL_SALE_XE_KEM = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Xe Kem"] || 0), 0);   
                const TOTAL_SALE_SALE = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Sale"] || 0), 0);
                const TOTAL_SALE_EVENT = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Event"] || 0), 0);
                const TOTAL_SALE_MANG_VE = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Mang Về"] || 0), 0);
                const TOTAL_SALE_GRAB = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Grab"] || 0), 0);
                const TOTAL_SALE_SHOPEE = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Shopee"] || 0), 0);
                const TOTAL_SALE_XANH = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Xanh"] || 0), 0);
                const TOTAL_SALE_BEFOOD = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Befood"] || 0), 0);
                const TOTAL_SALE_MOMO = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Momo"] || 0), 0);
                const TOTAL_SALE_WEB = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Web"] || 0), 0);
                const TOTAL_SALE_BO = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale BO"] || 0), 0);
                
                const TOTAL_TC_M = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC M"] || 0), 0);
                const TOTAL_TC_A = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC A"] || 0), 0);
                const TOTAL_TC_E = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC E"] || 0), 0);
                const TOTAL_TC_TOTAL = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Total"] || 0), 0);
                const TOTAL_TC_ON = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC On"] || 0), 0);
                const TOTAL_TC_OFF = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Off"] || 0), 0);
                const TOTAL_TC_TAI_CHO = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Tại chỗ"] || 0), 0);
                const TOTAL_TC_XE_KEM = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Xe kem"] || 0), 0);
                const TOTAL_TC_SALE = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Sale"] || 0), 0);
                const TOTAL_TC_EVENT = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Event"] || 0), 0);
                const TOTAL_TC_MANG_VE = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Mang về"] || 0), 0);
                const TOTAL_TC_GRAB = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Grab"] || 0), 0);
                const TOTAL_TC_SHOPEE = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Shopee"] || 0), 0);
                const TOTAL_TC_XANH = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Xanh"] || 0), 0);
                const TOTAL_TC_BEFOOD = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Befood"] || 0), 0);
                const TOTAL_TC_MOMO = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Momo"] || 0), 0);
                const TOTAL_TC_WEB = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Web"] || 0), 0);
                const TOTAL_TC_BO = datas.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC BO"] || 0), 0);

                const TOTAL_TA = Math.round(TOTAL_SALE_TOTAL/TOTAL_TC_TOTAL);

                const TOTAL_CASH_MONEY = datas.reduce((total, item) => total + (item?.["CashMoney"] || 0), 0);
                const TOTAL_CASH_MONEY_ONLINE = datas.reduce((total, item) => total + (item?.["CashOnlineMoney"] || 0), 0);
                const TOTAL_CREDIT_CARD_MONEY = datas.reduce((total, item) => total + (item?.["CreditCardMoney"] || 0), 0);

                const TOTAL_TRANSPORT_SALE = TOTAL_SALE_TAI_CHO + TOTAL_SALE_MANG_VE + TOTAL_SALE_XE_KEM + TOTAL_SALE_GRAB
                    + TOTAL_SALE_EVENT + TOTAL_SALE_XANH + TOTAL_SALE_BEFOOD + TOTAL_SALE_SALE + TOTAL_SALE_MOMO + TOTAL_SALE_SHOPEE;
                const TOTAL_ON_OFF_SALE = TOTAL_SALE_ON + TOTAL_SALE_OFF;

                const TOTAL_TRANSPORT_TC = TOTAL_TC_TAI_CHO + TOTAL_TC_MANG_VE + TOTAL_TC_XE_KEM + TOTAL_TC_GRAB
                    + TOTAL_TC_EVENT + TOTAL_TC_XANH + TOTAL_TC_BEFOOD + TOTAL_TC_SALE + TOTAL_TC_MOMO + TOTAL_TC_SHOPEE;
                const TOTAL_ON_OFF_TC = TOTAL_TC_ON + TOTAL_TC_OFF;

                const TOTAL_SALE_MAE = TOTAL_SALE_M + TOTAL_SALE_A + TOTAL_SALE_E;
                const TOTAL_TC_MAE = TOTAL_TC_M + TOTAL_TC_A + TOTAL_TC_E;

                setMetricSaleDatas({
                    TOTAL_SALE_M,
                    TOTAL_SALE_A,
                    TOTAL_SALE_E,
                    TOTAL_SALE_TOTAL,
                    TOTAL_SALE_ON,
                    TOTAL_SALE_OFF,
                    TOTAL_SALE_TAI_CHO,
                    TOTAL_SALE_XE_KEM,
                    TOTAL_SALE_SALE,
                    TOTAL_SALE_EVENT,
                    TOTAL_SALE_MANG_VE,
                    TOTAL_SALE_GRAB,
                    TOTAL_SALE_SHOPEE,
                    TOTAL_SALE_XANH,
                    TOTAL_SALE_BEFOOD,
                    TOTAL_SALE_MOMO,
                    TOTAL_SALE_WEB,
                    TOTAL_SALE_BO,
                    TOTAL_TC_M,
                    TOTAL_TC_A,
                    TOTAL_TC_E,
                    TOTAL_TC_TOTAL,
                    TOTAL_TC_ON,
                    TOTAL_TC_OFF,
                    TOTAL_TC_TAI_CHO,
                    TOTAL_TC_XE_KEM,
                    TOTAL_TC_SALE,
                    TOTAL_TC_EVENT,
                    TOTAL_TC_MANG_VE,
                    TOTAL_TC_GRAB,
                    TOTAL_TC_SHOPEE,
                    TOTAL_TC_XANH,
                    TOTAL_TC_BEFOOD,
                    TOTAL_TC_MOMO,
                    TOTAL_TC_WEB,
                    TOTAL_TC_BO,
                    TOTAL_TA,
                    TOTAL_CASH_MONEY,
                    TOTAL_CASH_MONEY_ONLINE,
                    TOTAL_CREDIT_CARD_MONEY,
                    TOTAL_TRANSPORT_SALE,
                    TOTAL_ON_OFF_SALE,
                    TOTAL_TRANSPORT_TC,
                    TOTAL_ON_OFF_TC,
                    TOTAL_SALE_MAE,
                    TOTAL_TC_MAE
                });
                //console.log("TOTAL_SALE_M:", TOTAL_SALE_M);
                // Group with Sale On Off
                const dataGroupedByWeek = _.groupBy(datas, 'Week');
                let _metricSaleOnOffDatas = [], _metricSaleAppDatas = [], _metricTCOnOffDatas = [], _metricTCAppDatas = [];
                //console.log("dataGroupedByWeek:", dataGroupedByWeek);

                Object.keys(dataGroupedByWeek).forEach(week => {
                    const weekData = dataGroupedByWeek[week];
                    const totalSaleOn = weekData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale On"] || 0), 0);
                    const totalSaleOff = weekData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Off"] || 0), 0);
                    const totalSaleGrab = weekData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Grab"] || 0), 0);
                    const totalSaleShopee = weekData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale Shopee"] || 0), 0);
                    const totalTCOn = weekData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC On"] || 0), 0);
                    const totalTCOff = weekData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Off"] || 0), 0);
                    const totalTCGrab = weekData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Grab"] || 0), 0);
                    const totalTCShopee = weekData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Shopee"] || 0), 0);

                    _metricSaleOnOffDatas.push({
                        name: week,
                        value: totalSaleOn,
                        value1: totalSaleOff
                    });
                    _metricSaleAppDatas.push({
                        name: week,
                        value: totalSaleGrab,
                        value1: totalSaleShopee
                    });

                    _metricTCOnOffDatas.push({
                        name: week,
                        value: totalTCOn,
                        value1: totalTCOff
                    });
                    _metricTCAppDatas.push({
                        name: week,
                        value: totalTCGrab,
                        value1: totalTCShopee
                    });
                });
                setMetricSaleOnOffDatas(_metricSaleOnOffDatas);
                setMetricSaleAppDatas(_metricSaleAppDatas);
                setMetricTCOnOffDatas(_metricTCOnOffDatas);
                setMetricTCAppDatas(_metricTCAppDatas);

                // Group by Date
                const dataGroupedByDay = _.groupBy(datas, 'Day');
                let _metricSaleDatasByDay = [], _metricTCDatasByDay = [];
                //console.log("dataGroupedByDay:", dataGroupedByDay);

                Object.keys(dataGroupedByDay).forEach(day => {  
                    const dayData = dataGroupedByDay[day];
                    const totalSaleM = dayData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale M"] || 0), 0);
                    const totalSaleA = dayData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale A"] || 0), 0);
                    const totalSaleE = dayData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["Sale E"] || 0), 0);
                    const totalTCM = dayData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC M"] || 0), 0);
                    const totalTCA = dayData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC A"] || 0), 0);
                    const totalTCE = dayData.reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC E"] || 0), 0);

                    _metricSaleDatasByDay.push({
                        name: day,
                        value: totalSaleM,
                        value2: totalSaleA,
                        value3: totalSaleE
                    });
                    _metricTCDatasByDay.push({
                        name: day,
                        value: totalTCM,
                        value2: totalTCA,
                        value3: totalTCE
                    });
                    //dataGroupedByDay[day] = { totalSale, totalTC };
                });

                _metricSaleDatasByDay = _.sortBy(_metricSaleDatasByDay, item => dayOrder.indexOf(item.name));
                _metricTCDatasByDay = _.sortBy(_metricTCDatasByDay, item => dayOrder.indexOf(item.name));
                console.log("_metricSaleDatasByDay:", _metricSaleDatasByDay);
                setMetricSaleDatasByDay(_metricSaleDatasByDay);
                setMetricTCDatasByDay(_metricTCDatasByDay);
            }
        } catch (error) {
            console.error("Error fetching sales data:", error);
        }
    }

    const getSaleDataByDailySales = async ({ storeName, fromDate, toDate }) => {
        //setIsLoading(true);
        try {
            const res = await httpClient.get(`/pos_sales?storeName=${storeName}&&fromDate=${fromDate}&&toDate=${toDate}&&limit=10_000_000`);
            console.log("Res data:", res.data);
            if(res.data.error) {
                console.log("Lỗi:" + JSON.stringify(res.data?.error?.message));
                setErrorMessage("Lỗi:" + JSON.stringify(res.data?.error?.message));
            } else {
                const datas = res.data?.data || [];
                console.log("_---- getSaleDataByDailySales - datas:", datas);
                setMetricDailySalesDatas(datas);
            }
        } catch (error) {
            console.error("Error fetching sales data:", error);
        }
    }

    const getGroupDatas = async({ storeName, fromDate, toDate }) => {
        try {
            const res = await httpClient.get(`/pos_groups?storeName=${storeName}&&fromDate=${fromDate}&&toDate=${toDate}&&limit=10_000_000`);
            //console.log("Res data:", res.data);
            if(res.data.error) {
                console.log("Lỗi:" + JSON.stringify(res.data?.error?.message));
                setErrorMessage("Lỗi:" + JSON.stringify(res.data?.error?.message));
            } else {
                const resPOSSALES = await httpClient.get(`/pos_sales?storeName=${storeName}&&fromDate=${fromDate}&&toDate=${toDate}&&limit=10_000_000`);
                const TOTAL_TC_TOTAL = (resPOSSALES.data?.data || []).reduce((total, item) => total + (item["SaleMetricsArray"]?.["TC Total"] || 0), 0);

                const datas = res.data?.data || [];
                const drinkGroupDatas = datas.filter(
                    item => (item.FoodGroup.indexOf("Nhóm Trà") !== -1) || (item.FoodGroup.indexOf("Nhóm Trà Kem") !== -1) || (item.FoodGroup.indexOf("Nhóm Kem") !== -1) 
                        || (item.FoodGroup.indexOf("Nhóm Cà Phê") !== -1) || (item.FoodGroup.indexOf("Nhóm Healthy") !== -1) 
                );
                const cakeGroupDatas = datas.filter(
                    item => (item.FoodGroup.indexOf("Nhóm Bánh") !== -1) 
                );
                const toppingGroupDatas = datas.filter(
                    item => (item.FoodGroup.indexOf("Nhóm Topping") !== -1) 
                );

                const TOTAL_SALE_DRINK = drinkGroupDatas.reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_MON_DRINK = drinkGroupDatas.reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_TC_MON = TOTAL_TC_TOTAL; //datas.reduce((total, item) => total + (item["Total"] || 0), 0);
                //    console.log("---- TOTAL_TC_TOTAL:", TOTAL_TC_TOTAL)
                // console.log("---- TOTAL_TC_MON:", TOTAL_TC_MON)

                const TOTAL_MON_TC_DRINK = TOTAL_MON_DRINK/(TOTAL_TC_MON || 1);
                const TOTAL_SALE_MON_DRINK = TOTAL_SALE_DRINK/(TOTAL_MON_DRINK || 1);
                const TOTAL_SALE_TC_DRINK = TOTAL_SALE_DRINK/(TOTAL_TC_MON || 1);

                const TOTAL_SALE_CAKE_PASTRY = cakeGroupDatas.reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_MON_CAKE_PASTRY = cakeGroupDatas.reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_MON_TC_CAKE = TOTAL_MON_CAKE_PASTRY/(TOTAL_TC_MON || 1);
                const TOTAL_SALE_MON_CAKE = TOTAL_SALE_CAKE_PASTRY/(TOTAL_MON_CAKE_PASTRY || 1);
                const TOTAL_SALE_TC_CAKE = TOTAL_SALE_CAKE_PASTRY/(TOTAL_TC_MON || 1);

                const TOTAL_SALE_TOPPING = toppingGroupDatas.reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_MON_TOPPING = toppingGroupDatas.reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_MON_TC_TOPPING = TOTAL_MON_TOPPING/(TOTAL_TC_MON || 1);
                const TOTAL_SALE_MON_TOPPING = TOTAL_SALE_TOPPING/(TOTAL_MON_TOPPING || 1);
                const TOTAL_SALE_TC_TOPPING = TOTAL_SALE_TOPPING/(TOTAL_TC_MON || 1);

                const TOTAL_SALE_GROUP_KEM = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Kem") !== -1)).reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_SALE_GROUP_COFFEE = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Cà Phê") !== -1)).reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_SALE_GROUP_TRA_KEM = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Trà Kem") !== -1)).reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_SALE_GROUP_TRA = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Trà") !== -1)).reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_SALE_GROUP_HEALTHY = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Healthy") !== -1)).reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_SALE_GROUP_TOPPING = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Topping") !== -1)).reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_SALE_GROUP_BANH = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Bánh") !== -1)).reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_SALE_GROUP_LUU_NIEM = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Lưu Niệm") !== -1)).reduce((total, item) => total + (item["Sale"] || 0), 0);
                const TOTAL_SALE_GROUP_NONG_SAN = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Nông Sản") !== -1)).reduce((total, item) => total + (item["Sale"] || 0), 0);
                
                const TOTAL_SALE_GROUP_SUM = 
                    TOTAL_SALE_GROUP_KEM + TOTAL_SALE_GROUP_COFFEE + TOTAL_SALE_GROUP_TRA_KEM +
                    TOTAL_SALE_GROUP_TRA + TOTAL_SALE_GROUP_HEALTHY + TOTAL_SALE_GROUP_TOPPING +
                    TOTAL_SALE_GROUP_BANH + TOTAL_SALE_GROUP_LUU_NIEM + TOTAL_SALE_GROUP_NONG_SAN;

                const TOTAL_MON_GROUP_KEM = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Kem") !== -1)).reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_MON_GROUP_COFFEE = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Cà Phê") !== -1)).reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_MON_GROUP_TRA_KEM = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Trà Kem") !== -1)).reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_MON_GROUP_TRA = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Trà") !== -1)).reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_MON_GROUP_HEALTHY = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Healthy") !== -1)).reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_MON_GROUP_TOPPING = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Topping") !== -1)).reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_MON_GROUP_BANH = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Bánh") !== -1)).reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_MON_GROUP_LUU_NIEM = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Lưu Niệm") !== -1)).reduce((total, item) => total + (item["Total"] || 0), 0);
                const TOTAL_MON_GROUP_NONG_SAN = datas.filter(item => (item.FoodGroup.indexOf("Nhóm Nông Sản") !== -1)).reduce((total, item) => total + (item["Total"] || 0), 0);

                const TOTAL_MON_GROUP_SUM = 
                    TOTAL_MON_GROUP_KEM + TOTAL_MON_GROUP_COFFEE + TOTAL_MON_GROUP_TRA_KEM +
                    TOTAL_MON_GROUP_TRA + TOTAL_MON_GROUP_HEALTHY + TOTAL_MON_GROUP_TOPPING +
                    TOTAL_MON_GROUP_BANH + TOTAL_MON_GROUP_LUU_NIEM + TOTAL_MON_GROUP_NONG_SAN;

                const TOTAL_MON_BILL_KEM = TOTAL_MON_GROUP_KEM/(TOTAL_TC_MON || 1);
                const TOTAL_MON_BILL_COFFEE = TOTAL_MON_GROUP_COFFEE/(TOTAL_TC_MON || 1);
                const TOTAL_MON_BILL_TRA_KEM = TOTAL_MON_GROUP_TRA_KEM/(TOTAL_TC_MON || 1);
                const TOTAL_MON_BILL_TRA = TOTAL_MON_GROUP_TRA/(TOTAL_TC_MON || 1);
                const TOTAL_MON_BILL_HEALTHY = TOTAL_MON_GROUP_HEALTHY/(TOTAL_TC_MON || 1);
                const TOTAL_MON_BILL_TOPPING = TOTAL_MON_GROUP_TOPPING/(TOTAL_TC_MON || 1);
                const TOTAL_MON_BILL_BANH = TOTAL_MON_GROUP_BANH/(TOTAL_TC_MON || 1);
                const TOTAL_MON_BILL_LUU_NIEM = TOTAL_MON_GROUP_LUU_NIEM/(TOTAL_TC_MON || 1);
                const TOTAL_MON_BILL_NONG_SAN = TOTAL_MON_GROUP_NONG_SAN/(TOTAL_TC_MON || 1);

                const TOTAL_SALE_MON_KEM = TOTAL_SALE_GROUP_KEM/(TOTAL_MON_GROUP_KEM || 1);
                const TOTAL_SALE_MON_COFFEE = TOTAL_SALE_GROUP_COFFEE/(TOTAL_MON_GROUP_COFFEE || 1);
                const TOTAL_SALE_MON_TRA_KEM = TOTAL_SALE_GROUP_TRA_KEM/(TOTAL_MON_GROUP_TRA_KEM || 1);
                const TOTAL_SALE_MON_TRA = TOTAL_SALE_GROUP_TRA/(TOTAL_MON_GROUP_TRA || 1);
                const TOTAL_SALE_MON_HEALTHY = TOTAL_SALE_GROUP_HEALTHY/(TOTAL_MON_GROUP_HEALTHY || 1);
                const TOTAL_SALE_MON_TOPPING_2 = TOTAL_SALE_GROUP_TOPPING/(TOTAL_MON_GROUP_TOPPING || 1);
                const TOTAL_SALE_MON_BANH = TOTAL_SALE_GROUP_BANH/(TOTAL_MON_GROUP_BANH || 1);
                const TOTAL_SALE_MON_LUU_NIEM = TOTAL_SALE_GROUP_LUU_NIEM/(TOTAL_MON_GROUP_LUU_NIEM || 1);
                const TOTAL_SALE_MON_NONG_SAN = TOTAL_SALE_GROUP_NONG_SAN/(TOTAL_MON_GROUP_NONG_SAN || 1);

                setMetricGroupDatas({
                    TOTAL_SALE_DRINK,
                    TOTAL_MON_DRINK,
                    TOTAL_TC_MON,
                    TOTAL_MON_TC_DRINK,
                    TOTAL_SALE_MON_DRINK,
                    TOTAL_SALE_TC_DRINK,

                    TOTAL_SALE_CAKE_PASTRY,
                    TOTAL_MON_CAKE_PASTRY,
                    TOTAL_MON_TC_CAKE,
                    TOTAL_SALE_MON_CAKE,
                    TOTAL_SALE_TC_CAKE,

                    TOTAL_SALE_TOPPING,
                    TOTAL_MON_TOPPING,
                    TOTAL_MON_TC_TOPPING,
                    TOTAL_SALE_MON_TOPPING,
                    TOTAL_SALE_TC_TOPPING,

                    TOTAL_SALE_GROUP_KEM,
                    TOTAL_SALE_GROUP_COFFEE,
                    TOTAL_SALE_GROUP_TRA_KEM,
                    TOTAL_SALE_GROUP_TRA,
                    TOTAL_SALE_GROUP_HEALTHY,
                    TOTAL_SALE_GROUP_TOPPING,
                    TOTAL_SALE_GROUP_BANH,
                    TOTAL_SALE_GROUP_LUU_NIEM,
                    TOTAL_SALE_GROUP_NONG_SAN,

                    TOTAL_MON_GROUP_KEM,
                    TOTAL_MON_GROUP_COFFEE,
                    TOTAL_MON_GROUP_TRA_KEM,
                    TOTAL_MON_GROUP_TRA,
                    TOTAL_MON_GROUP_HEALTHY,
                    TOTAL_MON_GROUP_TOPPING,
                    TOTAL_MON_GROUP_BANH,
                    TOTAL_MON_GROUP_LUU_NIEM,
                    TOTAL_MON_GROUP_NONG_SAN,

                    TOTAL_MON_BILL_KEM,
                    TOTAL_MON_BILL_COFFEE,
                    TOTAL_MON_BILL_TRA_KEM,
                    TOTAL_MON_BILL_TRA,
                    TOTAL_MON_BILL_HEALTHY,
                    TOTAL_MON_BILL_TOPPING,
                    TOTAL_MON_BILL_BANH,
                    TOTAL_MON_BILL_LUU_NIEM,
                    TOTAL_MON_BILL_NONG_SAN,

                    TOTAL_SALE_MON_KEM,
                    TOTAL_SALE_MON_COFFEE,
                    TOTAL_SALE_MON_TRA_KEM,
                    TOTAL_SALE_MON_TRA,
                    TOTAL_SALE_MON_HEALTHY,
                    TOTAL_SALE_MON_TOPPING_2,
                    TOTAL_SALE_MON_BANH,
                    TOTAL_SALE_MON_LUU_NIEM,
                    TOTAL_SALE_MON_NONG_SAN
                });

                setMetricSaleSmallGroupDatas([
                    { name: 'Nhóm Kem', value: Math.round(TOTAL_SALE_GROUP_KEM/TOTAL_SALE_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Nông Sản', value: Math.round(TOTAL_SALE_GROUP_NONG_SAN/TOTAL_SALE_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Bánh', value: Math.round(TOTAL_SALE_GROUP_BANH/TOTAL_SALE_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Topping', value: Math.round(TOTAL_SALE_GROUP_TOPPING/TOTAL_SALE_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Healthy', value: Math.round(TOTAL_SALE_GROUP_HEALTHY/TOTAL_SALE_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Trà', value: Math.round(TOTAL_SALE_GROUP_TRA/TOTAL_SALE_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Trà Kem', value: Math.round(TOTAL_SALE_GROUP_TRA_KEM/TOTAL_SALE_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Cà Phê', value: Math.round(TOTAL_SALE_GROUP_COFFEE/TOTAL_SALE_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Lưu Niệm', value: Math.round(TOTAL_SALE_GROUP_LUU_NIEM/TOTAL_SALE_GROUP_SUM*1000)/10 },
                ]);

                setMetricTCSmallGroupDatas([
                    { name: 'Nhóm Kem', value: Math.round(TOTAL_MON_GROUP_KEM/TOTAL_MON_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Nông Sản', value: Math.round(TOTAL_MON_GROUP_NONG_SAN/TOTAL_MON_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Bánh', value: Math.round(TOTAL_MON_GROUP_BANH/TOTAL_MON_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Topping', value: Math.round(TOTAL_MON_GROUP_TOPPING/TOTAL_MON_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Healthy', value: Math.round(TOTAL_MON_GROUP_HEALTHY/TOTAL_MON_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Trà', value: Math.round(TOTAL_MON_GROUP_TRA/TOTAL_MON_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Trà Kem', value: Math.round(TOTAL_MON_GROUP_TRA_KEM/TOTAL_MON_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Cà Phê', value: Math.round(TOTAL_MON_GROUP_COFFEE/TOTAL_MON_GROUP_SUM*1000)/10 },
                    { name: 'Nhóm Lưu Niệm', value: Math.round(TOTAL_MON_GROUP_LUU_NIEM/TOTAL_MON_GROUP_SUM*1000)/10 },
                ]);
            }

        } catch (error) {
            console.error("Error fetching sales data:", error);
        }
    }

    const getHourDatas = async({ storeName, fromDate, toDate }) => {
        try {
            const res = await httpClient.get(`/pos_hours?storeName=${storeName}&&fromDate=${fromDate}&&toDate=${toDate}&&limit=10_000_000`);
            //console.log("Res data:", res.data);
            if(res.data.error) {
                console.log("Lỗi:" + JSON.stringify(res.data?.error?.message));
                setErrorMessage("Lỗi:" + JSON.stringify(res.data?.error?.message));
            } else {
                const datas = res.data?.data || [];
                const dataGroupedByHour = _.groupBy(datas, 'HourSlot');
                const _metricHourDatas = [];
                let _totalSaleInAllHours = 0;

                Object.keys(dataGroupedByHour).forEach(hour => {
                    const hourData = dataGroupedByHour[hour];
                    const totalSale = hourData.reduce((total, item) => total + (item["Sale"] || 0), 0);
                    const totalTC = hourData.reduce((total, item) => total + (item["TC"] || 0), 0);
                    _totalSaleInAllHours += totalSale;
                    _metricHourDatas.push({ name: hour, value: 0, sale: totalSale });
                });
                _metricHourDatas.map(item => { 
                    item.value = Math.round((item.sale/_totalSaleInAllHours)*1000)/10;
                });
                //console.log("Data grouped by hour:", dataGroupedByHour);
                setMetricHourDatas(_metricHourDatas);
            }
        } catch (error) {
            console.error("Error fetching hour data:", error);
        }
    }

    const getItemDatas = async({ storeName, year }) => {
        try {
            const res = await httpClient.get(`/pos_items?storeName=${storeName}&&year=${year}&&limit=10_000_000`);
            //console.log("Res data:", res.data);
            if(res.data.error) {
                console.log("Lỗi:" + JSON.stringify(res.data?.error?.message));
                setErrorMessage("Lỗi:" + JSON.stringify(res.data?.error?.message));
            } else {
                const datas = res.data?.data || [];
                //console.log("-- Item datas:", datas);
                let _metricItemGroupDatas = [];
                let _itemGroupDatas = {};
                for(let i=1; i <= 12; i++) {
                    let _monthData = datas.filter(item => item.Month === (i < 10 ? "0" + i : i).toString());
                    // _monthData = _monthData.sort((a, b) => b.Total - a.Total);

                    let total = Object.values(_monthData).reduce((total, item) => total + (item.Total || 0), 0);
                    _monthData = _monthData.map(item => {
                        return {
                            ...item,
                            Percent: Math.round((item.Total/total)*1000)/10
                        }
                    });
                    //console.log("-- Month:", i, "monthData:", _monthData);
                    let monthDataGroup = _.mapValues(_.groupBy(_monthData, 'FoodName'), items => _.sumBy(items, 'Total'));
                    //console.log("-- Month:", i, "monthDataGroup", monthDataGroup);
                    let monthDataGroupToArray = [];
                    Object.keys(monthDataGroup).forEach(key => {
                        monthDataGroupToArray.push({
                            FoodName: key,
                            Total: monthDataGroup[key],
                            Percent: Math.round((monthDataGroup[key]/total)*1000)/10
                        })
                    });
                    monthDataGroupToArray = monthDataGroupToArray.sort((a, b) => b.Total - a.Total);
                    _itemGroupDatas[i] = monthDataGroupToArray;
                }
                let maxRowLength = 0;
                Object.keys(_itemGroupDatas).forEach(month => {
                    if(_itemGroupDatas[month].length > maxRowLength) {
                        maxRowLength = _itemGroupDatas[month].length;
                    }
                });
                for(let i=0; i < maxRowLength; i++) {
                    let row = [];
                    Object.keys(_itemGroupDatas).forEach(month => {
                        row.push(_itemGroupDatas[month][i] || { FoodName: "", Total: 0, Percent: 0 });
                    });
                    _metricItemGroupDatas.push(row);
                }       
                // console.log("----------------------- XXXXXXXXXXXXXXXXXXXXXXXXXXX")
                // console.log("-- Metric item group datas:", _metricItemGroupDatas);
                setMetricItemGroupDatas(_metricItemGroupDatas);
            }
        } catch (error) {
            console.error("Error fetching item data:", error);
        }
    }


    const handleDownload = async() => {
        const element = htmlDownloadRef.current;
        const canvas = await html2canvas(element, {
            scale: 2,
        });
        const data = canvas.toDataURL("image/png");
        const pxToMm = (px) => px * 0.264583;

        const width = pxToMm(canvas.width);
        const height = pxToMm(canvas.height);

        // const pdf = new jsPDF("p", "mm", "a4");
        // const imgProps = pdf.getImageProperties(data);
        // const pdfWidth = pdf.internal.pageSize.getWidth();
        // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;    

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: [width, height] // 🔥 dynamic size
        });
        
        pdf.addImage(data, "PNG", 0, 0, width, height);
        pdf.save(`report_${Date.now()}.pdf`);
    }

    const DashboardComponent = () => {
        return (
            <Flex ref={htmlDownloadRef} flexDirection="column" w="100%">
                <Row style={{ width: "100%", marginTop: 16 }} gutter={4}>
                    <Col xs={24} md={12}>
                        <Card style={{ backgroundColor: "#00b0ff" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>SALE TOTAL</span>}
                                value={intl.format(metricSaleDatas.TOTAL_SALE_TOTAL || 0)}
                                valueStyle={{ color: "white" }}
                                prefix={<span>$</span>}
                            />
                        </Card>
                    </Col>

                    <Col xs={24} md={12}>
                        <Card style={{ backgroundColor: "#33691e" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>TC TOTAL</span>}
                                value={intl.format(metricSaleDatas.TOTAL_TC_TOTAL || 0)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>

                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={6}>
                        <Card>
                            <Statistic 
                                title="SỐ LƯỢNG BILL"
                                value={intl.format(metricSaleDatas.TOTAL_TC_TOTAL || 0)}
                                valueStyle={{ color: "#2979ff" }}
                            />
                        </Card>
                    </Col>

                    <Col xs={24} md={6}>
                        <Card>
                            <Statistic 
                                title="TRUNG BÌNH BILL"
                                value={intl.format(metricSaleDatas.TOTAL_TA || 0)}
                                valueStyle={{ color: "#2979ff" }}
                            />
                        </Card>
                    </Col>

                    <Col xs={24} md={6}>
                        <Card>
                            <Statistic 
                                title="SỐ LƯỢNG MÓN CHÍNH"
                                value={intl.format(metricGroupDatas.TOTAL_MON_DRINK || 0)}
                                valueStyle={{ color: "#2979ff" }}
                            />
                        </Card>
                    </Col>

                    <Col xs={24} md={6}>
                        <Card>
                            <Statistic 
                                title="TRUNG BÌNH MÓN CHÍNH"
                                value={intl.format(metricSaleDatas.TOTAL_SALE_TOTAL / (metricGroupDatas.TOTAL_MON_DRINK || 1) || 0)}
                                valueStyle={{ color: "#2979ff" }}
                            />
                        </Card>
                    </Col>
                </Row>

                <Row style={{ width: "100%", marginTop: 16 }} gutter={4}>
                    <Col xs={24} md={8}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Doanh thu tiền mặt</span>}
                                value={intl.format(metricSaleDatas.TOTAL_CASH_MONEY || 0)}
                                valueStyle={{ color: "white" }}
                                prefix={<span>$</span>}
                            />
                        </Card>
                    </Col>

                    <Col xs={24} md={8}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Doanh thu online</span>}
                                value={intl.format(metricSaleDatas.TOTAL_CASH_MONEY_ONLINE || 0)}
                                valueStyle={{ color: "white" }}
                                prefix={<span>$</span>}
                            />
                        </Card>
                    </Col>

                    <Col xs={24} md={8}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Doanh thu cà thẻ</span>}
                                value={intl.format(metricSaleDatas.TOTAL_CREDIT_CARD_MONEY || 0)}
                                valueStyle={{ color: "white" }}
                                prefix={<span>$</span>}
                            />
                        </Card>
                    </Col>
                </Row>

                {/* Tỷ lệ % các loại hình thanh toán */}
                <Title level={4} type="success" style={{ marginTop: 20 }}>Sale mix</Title>
                {/* <Heading size="md" mb={2}>Sale mix</Heading> */}
                <Flex flexDirection="row" flexWrap="wrap">
                    <Flex flexDirection="column" w={{ base: "100%", md: "50%", lg: "50%" }}>
                        <Row style={{ width: "100%" }} gutter={4}>
                            <Col xs={24} md={6}>
                                <Card title="% Tại chỗ">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_TAI_CHO / metricSaleDatas.TOTAL_TRANSPORT_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Mang về">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_MANG_VE / metricSaleDatas.TOTAL_TRANSPORT_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Xe kem">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_XE_KEM / metricSaleDatas.TOTAL_TRANSPORT_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Grab">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_GRAB / metricSaleDatas.TOTAL_TRANSPORT_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Event">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_EVENT / metricSaleDatas.TOTAL_TRANSPORT_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Xanh">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_XANH / metricSaleDatas.TOTAL_TRANSPORT_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Befood">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_BEFOOD / metricSaleDatas.TOTAL_TRANSPORT_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Sale">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_SALE / metricSaleDatas.TOTAL_TRANSPORT_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Momo">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_MOMO / metricSaleDatas.TOTAL_TRANSPORT_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Shopee">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_SHOPEE / metricSaleDatas.TOTAL_TRANSPORT_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% ON">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_ON / metricSaleDatas.TOTAL_ON_OFF_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% OFF">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_OFF / metricSaleDatas.TOTAL_ON_OFF_SALE) * 1000)/10}/>
                                </Card>
                            </Col>
                        </Row>
                    </Flex>
                    
                    <Flex flexDirection="column" w={{ base: "100%", md: "50%", lg: "50%" }}>
                        <BarChartComponent data={metricSaleOnOffDatas} barNames={["Sale On", "Sale Off"]} title="Sale ON/OFF"/>
                        <BarChartComponent data={metricSaleAppDatas} barNames={["Sale Shopee", "Sale Grab"]} title="Sale - App"/>
                    </Flex>
                </Flex>

                {/* Tỷ lệ % các loại hình thanh toán */}
                <Title level={4} type="success" style={{ marginTop: 20 }}>TC mix</Title>
                {/* <Heading size="md" my={2}>TC mix</Heading> */}
                <Flex flexDirection="row" flexWrap="wrap">
                    <Flex flexDirection="column" w={{ base: "100%", md: "50%", lg: "50%" }}>
                        <Row style={{ width: "100%" }} gutter={4}>
                            <Col xs={24} md={6}>
                                <Card title="% Tại chỗ">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_TAI_CHO / metricSaleDatas.TOTAL_TRANSPORT_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Mang về">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_MANG_VE / metricSaleDatas.TOTAL_TRANSPORT_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Xe kem">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_XE_KEM / metricSaleDatas.TOTAL_TRANSPORT_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Grab">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_GRAB / metricSaleDatas.TOTAL_TRANSPORT_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Event">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_EVENT / metricSaleDatas.TOTAL_TRANSPORT_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Xanh">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_XANH / metricSaleDatas.TOTAL_TRANSPORT_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Befood">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_BEFOOD / metricSaleDatas.TOTAL_TRANSPORT_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Sale">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_SALE / metricSaleDatas.TOTAL_TRANSPORT_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Momo">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_MOMO / metricSaleDatas.TOTAL_TRANSPORT_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% Shopee">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_SHOPEE / metricSaleDatas.TOTAL_TRANSPORT_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% ON">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_ON / metricSaleDatas.TOTAL_ON_OFF_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col xs={24} md={6}>
                                <Card title="% OFF">
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_OFF / metricSaleDatas.TOTAL_ON_OFF_TC) * 1000)/10}/>
                                </Card>
                            </Col>
                        </Row>
                    </Flex>
                    <Flex flexDirection="column" w={{ base: "100%", md: "50%", lg: "50%" }}>
                        <BarChartComponent data={metricTCOnOffDatas} barNames={["TC On", "TC Off"]} title="TC ON/OFF"/>
                        <BarChartComponent data={metricTCAppDatas} barNames={["TC Grab", "TC Shopee"]} title="TC - App"/>
                    </Flex>
                </Flex>

                {/* Tỷ lệ % các loại hình khác */}
                <Title level={4} type="success" style={{ marginTop: 20 }}>Day part Sales mix</Title>
                <Flex flexDirection="row" flexWrap="wrap">
                    <Flex flexDirection="row" w="100%">
                        <Row style={{ width: "100%" }} gutter={4}>
                            <Col span={8}>
                                <Card title="AV Sale - Buổi sáng" style={{ backgroundColor: "#cddc39" }}>
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_M / metricSaleDatas.TOTAL_SALE_MAE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card title="AV Sale - Buổi chiều" style={{ backgroundColor: "#cddc39" }}>
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_A / metricSaleDatas.TOTAL_SALE_MAE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card title="AV Sale - Buổi tối" style={{ backgroundColor: "#cddc39" }}>
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_SALE_E / metricSaleDatas.TOTAL_SALE_MAE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col span={24}>
                                <LineChartComponent data={metricSaleDatasByDay}/>
                            </Col>
                        </Row>
                    </Flex>
                </Flex>

                <Title level={4} type="success" style={{ marginTop: 20 }}>Day part TC mix</Title>
                <Flex flexDirection="row" flexWrap="wrap">
                    <Flex flexDirection="row" w="100%">
                        <Row style={{ width: "100%" }} gutter={4}>
                            <Col span={8}>
                                <Card title="AV TC - Buổi sáng" style={{ backgroundColor: "#cddc39" }}>
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_M / metricSaleDatas.TOTAL_TC_MAE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card title="AV TC - Buổi chiều" style={{ backgroundColor: "#cddc39" }}>
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_A / metricSaleDatas.TOTAL_TC_MAE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card title="AV TC - Buổi tối" style={{ backgroundColor: "#cddc39" }}>
                                    <Progress type="dashboard" strokeColor="orange" percent={Math.round((metricSaleDatas.TOTAL_TC_E / metricSaleDatas.TOTAL_TC_MAE) * 1000)/10}/>
                                </Card>
                            </Col>
                            <Col span={24}>
                                <LineChartComponent data={metricTCDatasByDay} lineNames={["TC M", "TC A", "TC E"]} />
                            </Col>
                        </Row>
                    </Flex>
                    {/* <Flex flexDirection="column" w={{ base: "100%", md: "70%", lg: "70%" }}>
                        <Card title="AV Shift Metrics">
                            <LineChartComponent data={metricSaleDatasByDay}/>
                        </Card>
                        <Card title="AV Shift TC">
                            
                        </Card>
                    </Flex> */}
                </Flex>

                <Flex flexDirection="row" w="100%" mt={4}>
                    <Card style={{ width: "100%"}} title="Hourly TC mix"> 
                        {/* title="Biểu đồ phân bổ tỷ lệ % theo khung giờ" */}
                        <PieChartComponent data={metricHourDatas}/>
                        {/* <Center><Title level={5}>Hourly TC mix</Title></Center> */}
                    </Card>
                </Flex>

                {/* Product Mix - Big Group */}
                <Title level={4} type="success">Product Mix - Big Group</Title>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Drink [Sale]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_DRINK)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Drink [Món]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_DRINK)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Số lượng bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Drink [Món/bill]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_TC_DRINK)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Drink [Sale/Món]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_DRINK)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Drink [Sale/bill]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_TC_DRINK)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Cake [Sale]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_CAKE_PASTRY)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Cake [Món]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_CAKE_PASTRY)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Số lượng bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Cake [Món/Bill]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_TC_CAKE)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Cake [Sale/Món]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_CAKE)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Cake [Sale/bill]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_TC_CAKE)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Topping [Sale]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_TOPPING)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Topping [Món]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_TOPPING)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Số lượng bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Topping [Món/Bill]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_TC_TOPPING)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Topping [Sale/Món]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_TOPPING)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Topping [Sale/bill]</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_TC_TOPPING)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>

                <Flex flexDirection="row" w="100%" mt={4}>
                    <Card style={{ width: "100%"}} title="Category Sales Mix">
                        <PieChartComponent data={metricSaleSmallGroupDatas}/>
                        {/* <Center><Title level={5}>Category Sales Mix</Title></Center> */}
                    </Card>
                </Flex>
                <Flex flexDirection="row" w="100%" mt={4}>
                    <Card style={{ width: "100%"}} title="Category Quantity Mix">
                        <PieChartComponent data={metricTCSmallGroupDatas}/>
                    </Card>
                </Flex>

                <Title level={4} type="success">Product Mix - Small Group</Title>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale - Kem</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_GROUP_KEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Tổng Bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món - Kem</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_GROUP_KEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món/Bill - Kem</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_BILL_KEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#ff9800" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale/Món - Kem</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_KEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale - Cà Phê</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_GROUP_COFFEE)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Tổng Bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món - Cà Phê</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_GROUP_COFFEE)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món/Bill - Cà Phê</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_BILL_COFFEE)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#01579b" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale/Món - Cà Phê</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_COFFEE)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale - Trà Kem</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_GROUP_TRA_KEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Tổng Bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món - Trà Kem</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_GROUP_TRA_KEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món/Bill - Trà Kem</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_BILL_TRA_KEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#ffca28" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale/Món - Trà Kem</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_TRA_KEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#03a9f4" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale - Trà</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_GROUP_TRA)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#03a9f4" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Tổng Bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#03a9f4" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món - Trà</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_GROUP_TRA)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#03a9f4" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món/Bill - Trà</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_BILL_TRA)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#03a9f4" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale/Món - Trà</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_TRA)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#8bc34a" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale - Healthy</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_GROUP_HEALTHY)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#8bc34a" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Tổng Bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#8bc34a" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món - Healthy</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_GROUP_HEALTHY)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#8bc34a" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món/Bill - Healthy</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_BILL_HEALTHY)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#8bc34a" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale/Món - Healthy</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_HEALTHY)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#e040fb" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale - Topping</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_GROUP_TOPPING)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#e040fb" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Tổng Bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#e040fb" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món - Topping</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_GROUP_TOPPING)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#e040fb" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món/Bill - Topping</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_BILL_TOPPING)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#e040fb" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale/Món - Topping</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_TOPPING_2)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#689f38" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale - Bánh</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_GROUP_BANH)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#689f38" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Tổng Bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#689f38" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món - Bánh</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_GROUP_BANH)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#689f38" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món/Bill - Bánh</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_BILL_BANH)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#689f38" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale/Món - Bánh</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_BANH)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "brown" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale - Lưu Niệm</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_GROUP_LUU_NIEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "brown" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Tổng Bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "brown" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món - Lưu Niệm</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_GROUP_LUU_NIEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "brown" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món/Bill - Lưu Niệm</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_BILL_LUU_NIEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "brown" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale/Món - Lưu Niệm</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_LUU_NIEM)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ width: "100%" }} gutter={4}>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#90a4ae" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale - Nông Sản</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_GROUP_NONG_SAN)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#90a4ae" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Tổng Bill</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_TC_MON)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#90a4ae" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món - Nông Sản</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_GROUP_NONG_SAN)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={4}>
                        <Card style={{ backgroundColor: "#90a4ae" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Món/Bill - Nông Sản</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_MON_BILL_NONG_SAN)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} md={6}>
                        <Card style={{ backgroundColor: "#90a4ae" }}>
                            <Statistic 
                                title={<span style={{ color: "white" }}>Sale/Món - Nông Sản</span>}
                                value={intl.format(metricGroupDatas?.TOTAL_SALE_MON_NONG_SAN)}
                                valueStyle={{ color: "white" }}
                            />
                        </Card>
                    </Col>
                </Row>
            </Flex>
        )
    }

    const DailySalesComponent = ({ title, value, percent }) => {
        return (
            <Flex flexDirection="column" alignItems="center" justify="center" p={4} borderRadius={4} bg="#f5f5f5">
                <Text fontSize="lg" fontWeight="bold">{title}</Text>
                    <TableContainer mt={4}>
                    <Table variant="simple" size="sm">
                        <Thead>
                            <Tr textTransform="uppercase">
                                <Th textAlign="center" bg="blue.500" color="white">Name of Date</Th>
                                <Th textAlign="center" bg="blue.600" color="white">Daily</Th>
                                <Th textAlign="center" bg="blue.700" color="white">Week #</Th>
                                <Th textAlign="center" bg="blue.800" color="white">Sales ON</Th>
                                <Th textAlign="center" bg="blue.900" color="white">TC ON</Th>
                                <Th textAlign="center" bg="blue.500" color="white">TA ON</Th>
                                <Th textAlign="center" bg="blue.600" color="white">Sales OFF</Th>
                                <Th textAlign="center" bg="blue.700" color="white">TC OFF</Th>
                                <Th textAlign="center" bg="blue.800" color="white">TA OFF</Th>
                                <Th textAlign="center" bg="blue.900" color="white">Total Sales</Th>
                                <Th textAlign="center" bg="blue.500" color="white">Total TC</Th>
                                <Th textAlign="center" bg="blue.600" color="white">Total TA</Th>                            
                            </Tr>
    
                        </Thead>
                        <Tbody>
                            {
                                metricDailySalesDatas && metricDailySalesDatas.length > 0 &&
                                metricDailySalesDatas.map((item, idx) => {
                                    return (
                                        <Tr key={idx}>
                                            <Td>
                                                {item?.["Day"] || "--"}
                                            </Td>
                                            <Td>
                                                <b><FormattedDate value={item?.["Date"]} /></b>
                                            </Td>
                                            <Td>
                                                <b>{item?.["Week"] || "--"}</b>
                                            </Td>

                                            <Td>
                                                <b>{(intl.format(item?.["SaleMetricsArray"]?.["Sale On"] || 0)) || "--" }</b>
                                            </Td>
                                            <Td>
                                                <b>{(intl.format(item?.["SaleMetricsArray"]?.["TC On"] || 0)) || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{intl.format(item?.["SaleMetricsArray"]?.["Sale On"] / item?.["SaleMetricsArray"]?.["TC On"])}</b>
                                            </Td>

                                            <Td>
                                                <b>{(intl.format(item?.["SaleMetricsArray"]?.["Sale Off"] || 0)) || "--" }</b>
                                            </Td>
                                            <Td>
                                                <b>{(intl.format(item?.["SaleMetricsArray"]?.["TC Off"] || 0)) || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{intl.format(item?.["SaleMetricsArray"]?.["Sale Off"] / item?.["SaleMetricsArray"]?.["TC Off"])}</b>
                                            </Td>

                                            <Td>
                                                <b>{(intl.format( (item?.["SaleMetricsArray"]?.["Sale On"] + item?.["SaleMetricsArray"]?.["Sale Off"]) || 0) ) || "--" }</b>
                                            </Td>
                                            <Td>
                                                <b>{(intl.format( (item?.["SaleMetricsArray"]?.["TC On"] + item?.["SaleMetricsArray"]?.["TC Off"]) || 0) ) || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{intl.format((item?.["SaleMetricsArray"]?.["Sale On"] + item?.["SaleMetricsArray"]?.["Sale Off"]) / (item?.["SaleMetricsArray"]?.["TC On"] + item?.["SaleMetricsArray"]?.["TC Off"])) || "--"}</b>
                                            </Td>
                                        </Tr>
                                    )
                                })
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </Flex>
        )
    }

    const ItemGroupComponent = ({ title, value, percent }) => {
        return (
            <Flex flexDirection="column" alignItems="center" justify="center" p={4} borderRadius={4} bg="#f5f5f5">
                <Text fontSize="lg" fontWeight="bold">{title}</Text>
                    <TableContainer mt={4}>
                    <Table variant="simple" size="sm">
                        <Thead>
                            <Tr textTransform="uppercase">
                                <Th textAlign="center" colSpan={3} bg="blue.500" color="white">Tháng 1</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.600" color="white">Tháng 2</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.700" color="white">Tháng 3</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.800" color="white">Tháng 4</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.900" color="white">Tháng 5</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.500" color="white">Tháng 6</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.600" color="white">Tháng 7</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.700" color="white">Tháng 8</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.800" color="white">Tháng 9</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.900" color="white">Tháng 10</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.500" color="white">Tháng 11</Th>
                                <Th textAlign="center" colSpan={3} bg="blue.600" color="white">Tháng 12</Th>                            
                            </Tr>
                            <Tr textTransform="uppercase">
                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>

                                <Th>Tên món</Th>
                                <Th>Số lượng</Th>
                                <Th>Tỷ lệ</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                metricItemGroupDatas && metricItemGroupDatas.length > 0 &&
                                metricItemGroupDatas.map((item, idx) => {
                                    //const { FoodName, Total, Percent } = item;
                                    return (
                                        <Tr key={idx}>
                                            <Td>
                                                {item[0]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[0]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[0]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[1]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[1]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[1]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[2]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[2]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[2]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[3]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[3]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[3]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[4]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[4]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[4]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[5]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[5]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[5]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[6]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[6]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[6]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[7]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[7]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[7]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[8]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[8]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[8]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[9]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[9]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[9]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[10]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[10]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[10]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[11]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[11]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[11]?.["Percent"] || "--"}%</b>
                                            </Td>

                                            <Td>
                                                {item[12]?.["FoodName"] || "--"}
                                            </Td>
                                            <Td>
                                                <b>{item[12]?.["Total"] || "--"}</b>
                                            </Td>
                                            <Td>
                                                <b>{item[12]?.["Percent"] || "--"}%</b>
                                            </Td>
                                        </Tr>
                                    )
                                })
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </Flex>
        )
    }
    
    if(!isAllowAccessThisPage) {
        return (
            <Flex w="100%" p={4} flexDirection="column" alignItems="flex-start" justify="flex-start" h="100vh">
                <Text color="red.500"  fontSize="2xl" fontWeight="bold">**** Bạn không có quyền truy cập trang này (vui lòng liên hệ admin) ****</Text>
            </Flex>
        );
    }

    return (
        <Flex flexDirection="column" mt={{ base: 8, md: 0, lg: 0 }}>
            <Flex flexDirection="column" mx={4} my={4} opacity={isLoading ? 0.3 : 1} pointerEvents={isLoading ? "none" : "visible"}
            >   
                {
                    (selectedTabIndex === 0) &&
                    <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} flexWrap="wrap" 
                        align="center" justify="flex-start" spacing={4} mb={4} gap={2}
                    >
                        <Text>Chọn chi nhánh:</Text>
                        <div style={{ minWidth: "250px"}}>
                            <MultiSelect 
                                options={
                                    initDatas?.["Fabi05"] &&
                                        ([...Object.keys(initDatas?.["Fabi05"]).sort((a, b) => a.localeCompare(b))] || []).map((key, idx) => (
                                            { label: key, value: key }
                                        )) || []
                                }   
                                minWidth="200px"
                                value={selectedStoreNames}
                                onChange={setSelectedStoreNames}
                                labelledBy='Select'
                            />
                        </div>

                        <Text>Chọn từ ngày:</Text>
                        <DatePicker
                            value={selectedFromDate}
                            onChange={setSelectedFromDate}
                            className="react-date-picker-custom"
                            format='dd/MM/yyyy'                                                
                        />

                        <Text>Chọn đến ngày:</Text>
                        <DatePicker
                            value={selectedToDate}
                            onChange={setSelectedToDate}
                            className="react-date-picker-custom"
                            format='dd/MM/yyyy'                                                
                        />

                        <Button
                            px={8}
                            colorScheme="blue"
                            onClick={() => {
                                handleSearchByDate();
                            }
                        }>
                            <Icon as={MdSearch} boxSize={6}/> Tìm theo ngày
                        </Button>
                        <Button
                            px={8}
                            colorScheme="orange"
                            onClick={() => {
                                handleDownload();
                            }
                        }>
                            <Icon as={MdDownload} boxSize={6}/> Download PDF
                        </Button>
                    </Flex>
                }

                {
                    ((selectedTabIndex === 1) || (selectedTabIndex === 2)) &&
                    <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} flexWrap="wrap" 
                        align="center" justify="flex-start" spacing={4} mb={4} gap={2}
                    >
                        <Text>Chọn chi nhánh:</Text>
                        <div style={{ minWidth: "250px"}}>
                            <Select w={40} size="sm" value={selectedStoreName} placeholder='Chọn chi nhánh'
                                onChange={
                                    (evt) => { setSelectedStoreName(evt.target.value) }
                                }
                            >
                                {   initDatas?.["Fabi05"] &&
                                    (Object.keys(initDatas?.["Fabi05"]).sort((a, b) => a.localeCompare(b)) || []).map((key, idx) => (
                                        <option key={`store-${key}`} value={key}>{key}</option>
                                    ))
                                }
                            </Select>
                        </div>

                        <HStack justify="center" align="center">
                            <Text>Năm</Text>
                            <Input type='number' value={selectedYear} placeholder='Nhập năm' onChange={(e) => setSelectedYear(e.target.value)}/>
                        </HStack>

                        <Button
                            px={8}
                            colorScheme="blue"
                            onClick={() => {
                                handleSearchDailySalesAndItemGroup();
                            }
                        }>
                            <Icon as={MdSearch} boxSize={6}/> Tìm kiếm
                        </Button>
                    </Flex>
                }

                <HStack>
                    {
                        errorMessage &&
                        <Alert status="error" borderRadius={4}>
                            <AlertIcon />
                            <AlertDescription>{errorMessage}</AlertDescription>
                        </Alert>
                    }
                </HStack>
                 
                <Tabs p={2} onChange={(tabIdx)=> setSelectedTabIndex(tabIdx)}>
                    <TabList>
                        <Tab textTransform="uppercase">Dashboard</Tab>
                        <Tab textTransform="uppercase">Daily Sales</Tab>
                        <Tab textTransform="uppercase">Thống kê nhóm món</Tab>
                    </TabList>
                    <TabPanels onChange={(tabIdx)=> setSelectedTabIndex(tabIdx)}>
                        <TabPanel>
                            <DashboardComponent />
                        </TabPanel>
                        <TabPanel>
                            <DailySalesComponent title={`Daily Sales`}/>
                        </TabPanel>
                        <TabPanel>
                            <ItemGroupComponent title={`Thống kê loại thức uống`}/>
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Flex>
         
            {
                isLoading &&
                <Center>
                    <CircularProgress position="fixed" top="20vh" isIndeterminate size="200px" zIndex={9999}>
                        <CircularProgressLabel fontSize="24px" fontWeight="700" color="#2196f3">Loading</CircularProgressLabel>
                    </CircularProgress>
                </Center>
            }
        </Flex>
    )
}

export default Dashboard;